module.exports = __webpack_public_path__ + "static/media/workPvcCeilings12.26783a03.jpg";